/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import '../../../node_modules/leaflet/dist/leaflet.css';
@import '../../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css';

:host {
  display: block;
  width: 100%;
  height: 100%;

  .map-container {
    padding: 0;
    margin: 0 -2px 0 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .leaflet-top, .leaflet-bottom {
    z-index: 900;
  }

  .leaflet-container {
    width: 100%;
    height: 100%;
  }

  .leaflet-popup-content-wrapper {
    overflow-wrap: anywhere;
    img {
      max-width: 100%;
    }
  }
}
